module.exports = "/fonts/HelveticaNeueBold.woff?9a0b29b6d9d3a9d3e74ce03bed375aa4";